import React from "react";
import Modal from "react-modal/lib/components/Modal";
import HeaderSimple from "../../../../components/header/simple";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import { BtnBack } from "../../../../components/button/button-back";
import TextInput from "../../../../components/inputs/text";
import CheckboxInput from "../../../../components/inputs/check";
import libForm from "../../../../util/libForm";
import Loading from "../../../../components/loading";
import AlertMessage from "../../../../components/alert-message";
import { useGroupForm } from "./hook";

function ModalRegisterGroup({
	isOpen,
	handleClose,
	idGrupoToEdit,
	gruposMock,
	setGruposMock,
	setFilteredGrupos,
	grupoSelecionado,
	setGrupoSelecionado,
	fetchGrupos,
}) {
	const { register, handleSubmit, handleOnSubmit, errors, isSubmitting, isLoadingForm, watch } = useGroupForm(
		isOpen,
		handleClose,
		idGrupoToEdit,
		gruposMock,
		setGruposMock,
		setFilteredGrupos,
		grupoSelecionado,
		setGrupoSelecionado,
		fetchGrupos,
	);

	const isSubitem = watch ? watch("subitem") : false;

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={handleClose}
			overlayClassName="react-modal-overlay"
			className="modal-content-form modal-product-resize"
			shouldCloseOnOverlayClick={false}
		>
			<div className="container-forms">
				<HeaderSimple
					title={idGrupoToEdit ? "Editar Grupo de Complemento" : "Novo Grupo de Complemento"}
					subTitle="Dados do Grupo (Pai)"
					handleCloseModalRegister={handleClose}
				/>

				{isLoadingForm ? (
					<div className="flex items-center justify-center pt-8 pb-8">
						<Loading mensagem="Buscando dados do grupo atualizados..." />
					</div>
				) : (
					<form onSubmit={handleSubmit(handleOnSubmit)} className="form">
						<main>
							<div className="row">
								<TextInput
									label="Descrição do Grupo"
									id="descricao"
									placeholder="Ex: Tamanho da Pizza, Adicionais..."
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									autoFocus={true}
									className="col-12 col-sm-8 col-lg-8"
								/>

								<TextInput
									label="Qtde. máxima"
									id="qtde_max_escolha"
									placeholder="Qtd."
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-4 col-sm-4 col-lg-4"
								/>

								<TextInput
									label="Ordem de Exibição"
									id="ordem"
									placeholder="Ordem"
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-4 col-sm-4 col-lg-4"
								/>

								{/* OBS foi removido do schema antes, mas mantemos interface pro design se quiser */}
								<TextInput
									label="Observação"
									id="obs"
									placeholder="Opcional"
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-8 col-sm-8 col-lg-8"
								/>

								<div className="col-4 col-sm-4 col-lg-4 mt-3" style={{ opacity: isSubitem ? 0.6 : 1, pointerEvents: isSubitem ? "none" : "auto" }}>
									<CheckboxInput
										label="Seleção Obrigatória?"
										id="obrigatorio"
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className=""
									/>
									{isSubitem && (
										<span className="text-xs text-orange-600 block mt-1 ml-6">Sempre obrigatório para subitens</span>
									)}
								</div>

								<CheckboxInput
									label="Ativo"
									id="ativo"
									register={register}
									errors={errors}
									className="col-4 col-sm-4 col-lg-4 mt-3"
								/>

								<div className="col-12 mt-3">
									<CheckboxInput
										label="Subitem (Precificação Especial)"
										id="subitem"
										register={register}
										errors={errors}
										className="mb-1"
									/>
									<AlertMessage type="warning" title="Atenção" className="mt-2">
										Se ativado, o subitem o aplicativo exibirá este grupo com imagens maiores.{" "}
										<br />
										Os itens deste grupo{" "}
										<strong>
											substituirão o preço base do produto (assumindo o maior valor
											selecionado).{" "}
										</strong>
										Útil para "Tamanhos" ou "Sabores".
									</AlertMessage>
								</div>
							</div>
						</main>

						<footer>
							<BtnBack onClick={handleClose} isSubmitting={isSubmitting} />
							<BtnSubmit isSubmitting={isSubmitting} />
						</footer>
					</form>
				)}
			</div>
		</Modal>
	);
}

export default ModalRegisterGroup;
